import { Helmet } from 'react-helmet-async';

const SITE = 'https://shreeramagro.in';
const DEFAULT_IMAGE = 'https://shreeramagro.in/images/hero-poster.png';

export default function SEO({ title, description, path = '/', image = DEFAULT_IMAGE, keywords }) {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} — Shree Ram Agro Industries (ARV)`
    : 'Shree Ram Agro Industries (ARV) — Rotavator, Disc Harrow, Mulcher Manufacturer in Punjab, India';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
